import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import Box from "../../../components/Box";
import { Helpers } from "../../../helpers/Helpers";
import { KTCard } from "../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../_metronic/helpers/components/KTCardBody";
import Content from "../../../_metronic/layout/components/content/Content";
import { ToolbarWrapper } from "../../../_metronic/layout/components/toolbar";
import { PageTitle } from "../../../_metronic/layout/core";
import { useNavigate, useSearchParams } from "react-router-dom";
import { storeActivityIndicator } from "../../../redux/reducers/authSlice";
import toast from "react-hot-toast";
import { CustomSingleSelectModel } from "../../../components/CustomSingleSelect";
import { ConstantService } from "../../../services/ConstantService";
import { CustomMultiSelectModel } from "../../../components/CustomMultiSelect";
import { AddAmbarAgreementSchemeRequest } from "../../../models/request/ambarAgreementScheme/AddAmbarAgreementSchemeRequest";
import { AmbarAgreementSchemeService } from "../../../services/AmbarAgreementSchemeService";
import { AddAmbarAgreementSchemeResponse } from "../../../models/response/ambarAgreementScheme/AddAmbarAgreementSchemeResponse";
import { GetAmbarAgreementSchemeByIdResponse, GetAmbarAgreementSchemeByIdResponseAmbarAgreementSchemeField } from "../../../models/response/ambarAgreementScheme/GetAmbarAgreementSchemeByIdResponse";
import FieldDetails from "./Components/FieldDetails";
import PageHeader from "../../../components/PageHeader";
import { GetConstantListResponse } from "../../../models/response/constant/GetConstantListResponse";
import { MultiplierTypeEnum } from "../../../models/common/Enums";
import GeneralInformation from "./Components/GeneralInformation";

const AmbarAgreementSchemeAdd = () => {
    const navigate = useNavigate();
    const pageName = "Kargo Modülü > Nakliye > Anlaşma Şablonu"
    const [searchParams, setSearchParams] = useSearchParams();
    const dispatch = useDispatch();

    const generalInformationRef: any = useRef();
    const fieldInformationRef: any = useRef();

    const [ambarAgreementSchemeId, setAmbarAgreementSchemeId] = useState<string | undefined>(undefined);
    const [refNo, setRefNo] = useState<string | undefined>(undefined);
    const [name, setName] = useState<string | undefined>(undefined);
    const [description, setDescription] = useState<string | undefined>(undefined);
    const [isIncome, setIsIncome] = useState(true);
    const [isOutcome, setIsOutcome] = useState(false);
    const [selectedService, setSelectedService] = useState<CustomSingleSelectModel | undefined>(undefined);
    // Şablon birden çok müşteriye bağlanabilir; hiç seçilmezse bütün müşterilerde çalışır.
    const [selectedCustomers, setSelectedCustomers] = useState<CustomMultiSelectModel[]>([]);
    const [selectedCurrencyType, setSelectedCurrencyType] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedCarryTypes, setSelectedCarryTypes] = useState<CustomMultiSelectModel[]>([]);
    const [isCustomActive, setIsCustomActive] = useState(true);
    const [ambarAgreementSchemeFields, setAmbarAgreementSchemeFields] = useState<GetAmbarAgreementSchemeByIdResponseAmbarAgreementSchemeField[]>([]);
    const [selectedMultiplier, setSelectedMultiplier] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedIntervalType, setSelectedIntervalType] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [isComplete, setIsComplete] = useState(true);
    const [isScale, setIsScale] = useState(false);
    const [isDynamicService, setIsDynamicService] = useState(false);

    useEffect(() => {
        var id = searchParams.get("id");
        getData(id);
    }, [])

    const getData = async (_id: string | undefined | null = undefined) => {
        try {
            dispatch(storeActivityIndicator(true));

            var id = _id ? _id : searchParams.get("id") ? searchParams.get("id") : undefined;

            if (id) {
                var response: GetAmbarAgreementSchemeByIdResponse = await AmbarAgreementSchemeService.getAmbarAgreementSchemeById(id);

                if (!response.isSuccess) {
                    toast.error(response.message)
                    return;
                }

                setAmbarAgreementSchemeId(response.data.ambarAgreementSchemeId);
                setRefNo(response.data.refNo);
                setName(response.data.name);
                setDescription(response.data.description);

                setIsIncome(response.data.isIncome);
                setIsOutcome(response.data.isOutcome);

                if (response.data.multiplierId && response.data.multiplierName)
                    setSelectedMultiplier({ label: response.data.multiplierName, value: response.data.multiplierId });

                if (response.data.intervalTypeId && response.data.intervalTypeName)
                    setSelectedIntervalType({ label: response.data.intervalTypeName, value: response.data.intervalTypeId });

                if (response.data.serviceId && response.data.serviceName)
                    setSelectedService({ label: response.data.serviceName, value: response.data.serviceId });

                if (response.data.currencyTypeId && response.data.currencyTypeName)
                    setSelectedCurrencyType({ label: response.data.currencyTypeName, value: response.data.currencyTypeId });

                setIsComplete(response.data.isComplete);
                setIsScale(response.data.isScale);
                setIsCustomActive(response.data.isCustomActive);

                setSelectedCarryTypes(response.data.ambarAgreementSchemeCarryTypes.map(function (x) {
                    return { label: x.carryTypeName, value: x.carryTypeId }
                }));

                setSelectedCustomers((response.data.ambarAgreementSchemeCustomers ?? []).map(function (x) {
                    return { label: x.customerName, value: x.customerId }
                }));

                setAmbarAgreementSchemeFields(response.data.ambarAgreementSchemeFields);

                setIsDynamicService(response.data.isDynamicService);
            }
            else {
                var response2: GetConstantListResponse = await ConstantService.getConstantList('MULTIPLIER_TYPE', undefined, MultiplierTypeEnum.SIPARIS);

                if (!response2.isSuccess) {
                    toast.error(response2.message)
                    return;
                }

                setSelectedMultiplier({ label: response2.data[0].value, value: response2.data[0].constantId });

                var response3: GetConstantListResponse = await ConstantService.getConstantList('CURRENCY', undefined, 'TRY');

                if (!response3.isSuccess) {
                    toast.error(response3.message)
                    return;
                }

                setSelectedCurrencyType({ label: response3.data[0].value, value: response3.data[0].constantId });
            }
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }
    const saveAmbarAgreementScheme = async () => {
        try {
            if (Helpers.isEmpty(name))
                toast.error('Ad alanını doldurunuz!')
            else if (!isIncome && !isOutcome)
                toast.error('Gelir veya Gider alanını doldurunuz!')
            else if (!isComplete && !isScale)
                toast.error('Komple veya Baremli alanını doldurunuz!')
            else if (isComplete && !selectedMultiplier)
                toast.error('Çarpan alanını doldurunuz!')
            else if (isScale && !selectedIntervalType)
                toast.error('Aralık Türü alanını doldurunuz!')
            else if (!isDynamicService && !selectedService)
                toast.error('Hizmet Kalemi alanını doldurunuz!')
            else if (!selectedCurrencyType)
                toast.error('Döviz Cinsi alanını doldurunuz!')
            else {
                dispatch(storeActivityIndicator(true));

                var obj: AddAmbarAgreementSchemeRequest = {
                    ambarAgreementSchemeId: ambarAgreementSchemeId,
                    currencyTypeId: selectedCurrencyType?.value,
                    intervalTypeId: selectedIntervalType?.value,
                    isComplete: isComplete,
                    isCustomActive: isCustomActive,
                    isDynamicService: isDynamicService,
                    isIncome: isIncome,
                    isOutcome: isOutcome,
                    isScale: isScale,
                    multiplierId: selectedMultiplier?.value,
                    name: name,
                    description: description,
                    refNo: refNo,
                    serviceId: selectedService?.value,
                    ambarAgreementSchemeCustomerIds: selectedCustomers.map(x => x.value),
                    ambarAgreementSchemeCarryTypeIds: selectedCarryTypes.map(x => x.value),
                    ambarAgreementSchemeFields: ambarAgreementSchemeFields.map(function (x) {
                        return {
                            ambarAgreementSchemeFieldId: x.ambarAgreementSchemeFieldId.startsWith('newrecrd') ? undefined : x.ambarAgreementSchemeFieldId,
                            fieldId: x.fieldId,
                            operatorId: x.operatorId,
                            fieldName: x.fieldName,
                        }
                    }),
                }

                var response: AddAmbarAgreementSchemeResponse = await AmbarAgreementSchemeService.addAmbarAgreementScheme(obj);

                if (!response.isSuccess) {
                    toast.error(response.message);
                    dispatch(storeActivityIndicator(false));
                    return;
                }

                toast.success(response.message)

                dispatch(storeActivityIndicator(false));
                navigate(Helpers.getGoBackUrl())
            }
        } catch (error: any) {
            toast.error(error);
            dispatch(storeActivityIndicator(false));
        }
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={undefined} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Box className="mb-10">
                <Content>
                    <PageHeader
                        items={[
                            { text: 'Genel Bilgiler', ref: generalInformationRef },
                            { text: 'Eşleştirme Alanları', ref: fieldInformationRef },
                        ]}
                    />

                    <GeneralInformation
                        generalInformationRef={generalInformationRef}
                        isComplete={isComplete}
                        isCustomActive={isCustomActive}
                        isIncome={isIncome}
                        isOutcome={isOutcome}
                        isScale={isScale}
                        name={name}
                        refNo={refNo}
                        selectedCarryTypes={selectedCarryTypes}
                        selectedCurrencyType={selectedCurrencyType}
                        selectedIntervalType={selectedIntervalType}
                        selectedMultiplier={selectedMultiplier}
                        selectedService={selectedService}
                        selectedCustomers={selectedCustomers}
                        setIsComplete={setIsComplete}
                        setIsCustomActive={setIsCustomActive}
                        setIsIncome={setIsIncome}
                        setIsOutcome={setIsOutcome}
                        setIsScale={setIsScale}
                        setName={setName}
                        description={description}
                        setDescription={setDescription}
                        setRefNo={setRefNo}
                        setSelectedCarryTypes={setSelectedCarryTypes}
                        setSelectedCustomers={setSelectedCustomers}
                        setSelectedCurrencyType={setSelectedCurrencyType}
                        setSelectedIntervalType={setSelectedIntervalType}
                        setSelectedMultiplier={setSelectedMultiplier}
                        setSelectedService={setSelectedService}
                        isDynamicService={isDynamicService}
                        setIsDynamicService={setIsDynamicService}
                    />

                    <FieldDetails
                        fieldInformationRef={fieldInformationRef}
                        setAmbarAgreementSchemeFields={setAmbarAgreementSchemeFields}
                        ambarAgreementSchemeFields={ambarAgreementSchemeFields}
                    />

                    <KTCard className="ebbe-card mt-10">
                        <KTCardBody>
                            <Box flexDirection="row" justifyContent="flex-end">
                                <Box mr="15px">

                                    <button className="btn btn-sm btn-light btn-active-light-primary" onClick={() => navigate(Helpers.getGoBackUrl())}>Geri</button>
                                </Box>
                                <Box>
                                    <button className="btn btn-primary btn-sm" onClick={saveAmbarAgreementScheme}>Kaydet</button>
                                </Box>
                            </Box>
                        </KTCardBody>
                    </KTCard>
                </Content>
            </Box>
        </React.Fragment >
    )
}

export default AmbarAgreementSchemeAdd;